import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import Dashboard from './Dashboard';
import Template from './Template';
import Messages from './Messages';
import Partners from './Partners';
import Info from './Pages';
import Help from './Help';
import Contact from './Contact';
// import Statistics from './Statistics';
import SideNav from './SideNav';
import ReadMessage from './ReadMessage';
import { PAGES_PATH, DASHBOARD_PATH, PARTNERS_PATH, MESSAGES_PATH, MESSAGES_DETAIL_PATH, HELP_PATH, CLIENT_CONTACT_PATH } from '../../constants';
import { IOrganization, IAccountDetails, IAlerts } from 'src/services/account';
import { IAvatar } from 'src/services/documents';

function FragmentSupportingSwitch({ children }: { children: any }) {
  const flattenedChildren: any = [];
  flatten(flattenedChildren, children);
  return React.createElement.apply(React, [Switch, null].concat(flattenedChildren));
}

function flatten(target: any, children: any) {
  React.Children.forEach(children, (child: { props: { children: any } }) => {
    if (React.isValidElement(child)) {
      if (child.type === React.Fragment) {
        flatten(target, child.props.children);
      } else {
        target.push(child);
      }
    }
  });
}

const routes: IRoute[] = [
  {
    name: 'Dashboard',
    icon: 'home',
    path: DASHBOARD_PATH,
    component: Dashboard,
    children: [
      {
        name: 'Help',
        path: HELP_PATH,
        component: Help
      },
      {
        name: 'Contact Us',
        path: CLIENT_CONTACT_PATH,
        component: Contact
      },
    ]
  },
  {
    name: 'Messages',
    icon: 'envelope',
    path: MESSAGES_PATH,
    component: Messages,
    children: [
      {
        name: 'ReadMessage',
        path: MESSAGES_DETAIL_PATH,
        component: ReadMessage
      },
    ]
  },
  {
    name: 'Partners',
    icon: 'user-alt',
    path: PARTNERS_PATH,
    component: Partners
  },
  {
    name: 'Info Pages',
    icon: 'file-alt',
    path: PAGES_PATH,
    component: Info
  },

  // {
  //   name: 'Statistics',
  //   icon: 'chart-line',
  //   path: `${CLIENT_PATH}/dashboard/statistics`,
  //   component: Statistics
  // }
]

export default (props: { location: Location, accountDetails: IAccountDetails | null | undefined, organization: IOrganization | null | undefined, avatar: IAvatar | null | undefined, alerts: IAlerts | null | undefined, updateAlertCounts: IUpdateAlertCounts }) => {

  {/* TODO render loading indicator or somfin */ }
  if (!props.accountDetails || !props.organization) return null
  return (
    <React.Fragment>
      <div className="d-flex flex-row flex-fill" >
        <div className="col left-nav">
          <SideNav location={props.location} routes={routes} alerts={props.alerts} />
        </div>
        <div className="col">
          <Switch>
            <FragmentSupportingSwitch>
              {routes.map(route => {
                return (<React.Fragment key={`route-${route.path}`}>
                  <Route exact path={route.path} render={({ ...x }) => <route.component {...x} accountDetails={props.accountDetails} organization={props.organization} avatar={props.avatar} alerts={props.alerts} updateAlertCounts={props.updateAlertCounts} />} />
                  {route.children && route.children.map(subPath => {
                    return <Route key={subPath.path} exact path={subPath.path} render={({ ...x }) => <subPath.component {...x} accountDetails={props.accountDetails} organization={props.organization} updateAlertCounts={props.updateAlertCounts} />} />
                  })}
                </React.Fragment>)
              })}
              <Route path="/client/dashboard/template" component={Template} />
            </FragmentSupportingSwitch>
          </Switch>
        </div>
      </div>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/client/dashboard/index.tsx